import NHError from "./CustomError";
export default class FetchUserError extends NHError {
  constructor(message, internal = true) {
    super(message, internal);
    this.name += ": FetchUserError";
  }
}
